import { i18nMixin } from '@kisters/wcp-base/decorators';
import { customElement } from 'lit/decorators.js';
import {
  BaseTable,
  Export,
  Selection,
  ColumnFormatter,
  SortAble,
  LazyRendering,
} from '@kisters/wcp-base/components';
import { Mix } from '@kisters/wcp-base/common';
import { css } from 'lit';
import nls from '../../locales/index';

const Parent = Mix(
  BaseTable,
  Selection,
  ColumnFormatter,
  LazyRendering,
  SortAble,
  Export,
);

@customElement('ki-ts-viewer-table')
export default class KiTsViewerTable extends Mix(Parent, [i18nMixin, { nls }]) {
  static styles = [
    ...Parent.styles,
    css`
      :host {
        height: 100%;
      }
      .col-value {
        text-align: right;
      }
      .header .header-content {
        padding: 10px 5px;
        hyphens: auto;
        text-align: left;
      }
      .table {
        font-size: 14px;
      }
      .table .body .cell {
        padding: 5px 5px;
      }
      .selection-col {
        display: none;
      }
      .row {
        cursor: default;
      }
    `,
  ];
}
